<template>
	<section class="newsletter-section align-center">
		<div class="row">
			<div class="columns column6 align-left">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column6 align-right">
				<form
					id="sib-form"
					action="https://a469a47a.sibforms.com/serve/MUIFALhcJMoU8tbs2W_-E-eVoGO627l48mkE82Z2vhoMEepenmpKByFH9PVhovV9L7w7NKByUlY2uUsE8aMOUrs9rFRiEhB9cs-HsSm8KR9-B2PcQXvIY6er_q6r5KGeXHUZ-wKvGcM6oj8yNr0RgTyHmEmiPJdRDFCfbNBipNuUJv1qmPztu_mJ0JB1ln0-oRE02Lz9Ft5irKbs"
					method="post"
					name="sib-form"
					class="newsletter"
					target="_blank"
				>
					<div class="mc-field-group">
						<input
							id="EMAIL"
							class="input"
							type="email"
							name="EMAIL"
							autocomplete="off"
							:placeholder="$t('formEmail')"
							data-required="true"
							required
						/>
						<button class="button action" form="sib-form" type="submit">{{ $t('formSubmit') }}</button>
						<input
							type="text"
							name="email_address_check"
							value=""
							style="display: none"
							class="hidden input--hidden"
						/>
						<input type="hidden" name="locale" value="en" />
						<input type="hidden" name="html_type" value="simple" />
					</div>
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: 'Subscribe' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	padding: 75px 0;
	background: var(--tertiary-background-color);
	color: var(--body-color);

	h3,
	:deep(p) {
		color: #fff;
	}

	form {
		input {
			background: var(--tertiary-background-color);
			outline: 2px solid #fff;
			font: inherit;
			padding: 15px;
			margin: 10px 5px;
			height: 52px;
			border: none;
			width: 100%;
			max-width: 400px;
			vertical-align: top;
			color: #fff;
			border-radius: 0;

			&::placeholder {
				color: #fff;
			}

			&.button {
				line-height: 22px;
				background: var(--cta-color);
				color: #fff;
				max-width: 200px;
				outline: 2px solid var(--cta-color);
				font-weight: 800;
				letter-spacing: 1px;

				&:hover {
					background: #fff;
					outline: 2px solid #fff;
					color: var(--cta-color-hover);
				}
			}
		}

		.mc-field-group {
			display: flex;
			align-items: center;
			gap: 10px;

			.input {
				flex: 1;
			}

			.button.action {
				all: unset; // Verwijdert standaard styling
				display: inline-flex;
				align-items: center;
				justify-content: center;
				padding: 0 20px;
				height: 52px; // Gelijk aan input
				background: var(--cta-color);
				color: #fff;
				cursor: pointer;
				font-weight: 800;
				letter-spacing: 1px;
				outline: 2px solid var(--cta-color);
				text-transform: uppercase;

				&:hover {
					background: #fff;
					color: var(--cta-color-hover);
					outline: 2px solid #fff;
				}
			}
		}
	}
}

@media (max-width: 900px) {
	.newsletter-section .row {
		flex-direction: column;
		align-items: stretch;

		.columns {
			width: 100%;
			text-align: center; // Optional: centers content nicely
			margin-bottom: 20px; // Adds spacing between stacked columns
		}

		form {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin: 0 auto;

			input {
				max-width: 100%;
				margin: 5px 0;
				text-align: center;
			}

			.mc-field-group {
				flex-flow: column;
				align-items: stretch;
				width: 70%;
			}
		}
	}
}
</style>
